import styled from 'styled-components';

import { COLORS, STATUS_COLORS } from '../../theme/tokens';
import { Text } from '../Text/Text';

export type StatTone = 'default' | 'positive' | 'negative' | 'accent';

export const TONE_COLOR: Record<StatTone, string> = {
  default: COLORS.text,
  positive: STATUS_COLORS.positive,
  negative: STATUS_COLORS.negative,
  accent: COLORS.accentMagenta,
};

export const StatGrid = styled.div<{ $columns: number }>`
  display: grid;
  grid-template-columns: repeat(${(p) => p.$columns}, 1fr);
  gap: 12px;
`;

/** Hairline-divided wrapper for a stat row; dims when `$muted` (e.g. disabled). */
export const StatsWrap = styled.div<{ $muted?: boolean }>`
  padding-top: 12px;
  border-top: 1px solid ${COLORS.hairline};
  opacity: ${(p) => (p.$muted ? 0.4 : 1)};
`;

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const Label = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

export const Value = styled.div<{ $color: string }>`
  font-size: 15px;
  font-weight: 600;
  color: ${(p) => p.$color};
`;
